/**
 * Bedrock slime chunks: a chunk is a slime chunk when the first output of an
 * MT19937 seeded with `(cx * 0x1F1F1F1F) ^ cz` (32-bit wrap, chunk coords as
 * uint32) is divisible by 10. Independent of the world seed (unlike Java,
 * whose formula uses java.util.Random and the seed).
 *
 * Only the first MT output is needed, which depends on the state words
 * 0, 1 and 397, so the generator is initialised just that far.
 */

/** First `genrand_int32()` of `init_genrand(seed)` (standard MT19937). */
export function mt19937First(seed: number): number {
  const mt = new Uint32Array(398);
  mt[0] = seed >>> 0;
  for (let i = 1; i < 398; i++) mt[i] = (Math.imul(1812433253, mt[i - 1] ^ (mt[i - 1] >>> 30)) + i) >>> 0;
  const y = (mt[0] & 0x80000000) | (mt[1] & 0x7fffffff);
  let v = mt[397] ^ (y >>> 1) ^ ((y & 1) !== 0 ? 0x9908b0df : 0);
  v ^= v >>> 11;
  v ^= (v << 7) & 0x9d2c5680;
  v ^= (v << 15) & 0xefc60000;
  v ^= v >>> 18;
  return v >>> 0;
}

/** Is chunk (cx, cz) a slime chunk? */
export function isSlimeChunk(cx: number, cz: number): boolean {
  const seed = (Math.imul(cx | 0, 0x1f1f1f1f) ^ (cz | 0)) >>> 0;
  return mt19937First(seed) % 10 === 0;
}
